import { Anchor, Badge, Card, Grid, Text } from '@mantine/core';
import { useLocation } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';
import AbTestStopElement from './AbTestStopElement';

const AbTestCard = ({ abTest, stopAbTest }) => {
  const location = useLocation();

  return (
    <Card withBorder mb="md">
      <Card.Section withBorder inheritPadding py="xs">
        <Grid align="center">
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <div>
              <Text size="sm" c="dimmed">
                Started at:
              </Text>
              <Anchor href={`#${location.pathname}/${abTest.id}/details`} ta="left">
                <Text fw={700}> {new Date(abTest.periodStart).toDateString()}</Text>
              </Anchor>
            </div>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <div>
              <Text size="sm" c="dimmed">
                Control group fraction:
              </Text>
              <div>
                <Badge variant="default">{(abTest.controlGroupFraction / 100.0).toFixed(0)}%</Badge>
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <div>
              <Text size="sm" c="dimmed">
                Hypothesis:
              </Text>
              <div>
                <Badge variant="default">{prettifiedLabel(abTest.hypothesis)}</Badge>
              </div>
            </div>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 2 }}>
            <div>
              {abTest.running ? (
                <>
                  <Text size="sm" c="dimmed">
                    Running:
                  </Text>
                  <div>
                    <Badge variant="default">Yes</Badge>
                  </div>
                </>
              ) : (
                <>
                  <Text size="sm" c="dimmed">
                    Ended at:
                  </Text>
                  <div>
                    <Badge variant="default">{new Date(abTest.periodEnd).toDateString()}</Badge>
                  </div>
                </>
              )}
            </div>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 1 }}>
            {stopAbTest ? <AbTestStopElement abTest={abTest} stopAbTest={stopAbTest} /> : null}
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default AbTestCard;
